module.exports = __webpack_public_path__ + "static/media/close.b840e171.svg";